import { FunctionComponent, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@store/store";
import {
  selectPlanView,
  selectPlanItems,
  setPlanViewAction,
  PlanView as PlanViewType,
} from "@store/plan/planReducer";
import { PlanEdit } from "../PlanEdit/PlanEdit";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { PlanNavigate } from "../PlanNavigate/PlanNavigate";
import { EmptyPlan } from "../EmptyPlan/EmptyPlan";
import { PlanView } from "../PlanView/PlanView";
import { useLocation } from "react-router";
import { selectDirections } from "@store/planRouteReducer";

import "./Plan.css";

const Plan: FunctionComponent = () => {
  const planItems = useAppSelector(selectPlanItems);
  const planView = useAppSelector(selectPlanView);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isMobile } = useWindowSize();
  const directions = useAppSelector(selectDirections);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let view = params.get("planView");
    if (view === "navigate" && (directions?.length ?? 0) === 0) {
      // TODO: remove this and make navigation work when directions are empty, eg: add a loader
      // and a failed state to return to user plan. This is to handle when a user goes directly
      // to navigate on page load.
      view = "list";
    }
    dispatch(setPlanViewAction((view ?? "list") as PlanViewType));
  }, [location.search, dispatch, directions]);

  if (planView === "navigate" && isMobile) {
    return null;
  }

  return (
    <div className="plan-component">
      {planView === "list" && planItems.length > 0 && <PlanView />}
      {planView === "list" && planItems.length === 0 && <EmptyPlan />}
      {planView === "edit" && <PlanEdit />}
      {planView === "navigate" && <PlanNavigate />}
    </div>
  );
};

export { Plan };
